(function () {
  "use strict";

  MfTextLengthCtrl.$inject = ['$scope', '$attrs', '$parse'];
  angular
    .module('trainerWebApp.directives')
    .controller('MfTextLengthCtrl', MfTextLengthCtrl)
    .directive('mfTextLength', mfTextLength);

  function MfTextLengthCtrl($scope, $attrs, $parse) {
    var textLength = parseInt($attrs.mfTextLength || 40);
    var warnAtLength = parseInt($attrs.mfTextWarnAt || textLength - 10);

    this.textLengthStateChangeCb = function () {};
    if ($attrs.mfTextLengthStateChangeCb)
      this.textLengthStateChangeCb = $parse($attrs.mfTextLengthStateChangeCb);

    var states = {
      ok: {
        test: function (len) {
          return len < warnAtLength;
        },
        style: $attrs.mfTextOkClass || 'mf-text-length-off',
        text: function () {
          return '';
        },
        lengthValid: true
      },
      near: {
        test: function (len) {
          return len >= warnAtLength && len < textLength;
        },
        style: $attrs.mfTextNearClass || 'mf-text-length-near',
        text: function (len) {
          return len + ' / ' + textLength;
        },
        lengthValid: true
      },
      at: {
        test: function (len) {
          return len == textLength;
        },
        style: $attrs.mfTextAtClass || 'mf-text-length-at',
        text: function (len) {
          return len + ' / ' + textLength;
        },
        lengthValid: true
      },
      over: {
        test: function (len) {
          return len > textLength;
        },
        style: $attrs.mfTextOverClass || 'mf-text-length-over',
        text: function (len) {
          return len + ' / ' + textLength;
        },
        lengthValid: false
      }
    };

    this.getState = function (text) {
      var textLength = (text || '').length;
      var state;

      for (var key in states) {
        state = states[key];
        if (state.test(textLength)) {
          return {
            style: state.style,
            text: state.text(textLength),
            lengthValid: state.lengthValid
          };
        }
      }
      return {};
    };

    this.statesAreDifferent = function (state1, state2) {
      return state1.text != state2.text || state1.style != state2.style;
    };

    // sick sick shit from https://gist.github.com/1308368
    this.createIndicatorId = function () {
      for (var a = '', b = ''; a++ < 36; b += a * 51 & 52 ? (a ^ 15 ? 8 ^ Math.random() * (a ^ 20 ? 16 : 4) : 4).toString(16) : '');
      return 'text-length-indicator-' + b;
    };
  }

  function mfTextLength() {
    return {
      controller: 'MfTextLengthCtrl',
      link: function (scope, element, attrs, ctrl) {
        var watch = function () {};
        var state;
        var indicator;

        scope.$on('$destroy', watch);

        function addIndicator() {
          var indicatorId = ctrl.createIndicatorId();
          indicator = $('<span id="' + indicatorId + '" class="' + state.style + '">' + state.text + '</span>');
          element.parent().append(indicator);
        }

        var onModelChange = function (newValue, oldValue) {
          var newState = ctrl.getState(newValue);
          if (!ctrl.statesAreDifferent(state, newState))
            return;

          state = newState;
          ctrl.textLengthStateChangeCb(state);

          $(indicator).attr({'class': state.style});
          $(indicator).text(state.text);

          if (state.text.length === 0)
            $(element).removeClass('indicator-visible');
          else
            $(element).addClass('indicator-visible');
        };

        function setup() {
          state = ctrl.getState();
          addIndicator();
          watch = scope.$watch(attrs['ngModel'], onModelChange, true);
        }

        setup();
      }
    };
  }

})();
